export default "__VITE_ASSET__BP_owZgn__"